import * as yup from 'yup';

import { COUNTRY_USA, COUNTRY_CANADA, NOT_BLANK_REGEX } from 'utils/constants';

import { usaStates, canadaStates } from './subcomponents/AddressForm/options';
import { shippingMethods } from './subcomponents/ShippingMethodForm/options';

export const getValidationSchema = () => {
  const STATE_MANDATORY_MSG = 'State is mandatory.';

  // Generates arrays of option ids to be validated
  const usaStateOptions = usaStates.map(({ id }) => id);
  const canadaStateOptions = canadaStates.map(({ id }) => id);
  const methodOptions = shippingMethods.map(({ id }) => id);

  /* eslint-disable no-template-curly-in-string */
  return yup.object().shape({
    address1: yup
      .string()
      .max(255, 'Address Line 1 is limited to ${max} characters')
      .matches(NOT_BLANK_REGEX, 'Address Line 1 is mandatory.'),
    address2: yup
      .string()
      .max(255, 'Address Line 2 is limited to ${max} characters'),
    city: yup
      .string()
      .max(60, 'City is limited to ${max} characters')
      .matches(NOT_BLANK_REGEX, 'City is mandatory.'),
    state: yup
      .string()
      .max(60, 'State is limited to ${max} characters')
      .when('country', (country, schema) => {
        if (country === COUNTRY_USA) {
          return schema.oneOf(usaStateOptions, STATE_MANDATORY_MSG);
        } else if (country === COUNTRY_CANADA) {
          return schema.oneOf(canadaStateOptions, STATE_MANDATORY_MSG);
        } else {
          return schema;
        }
      }),
    zipcode: yup
      .string()
      .max(60, 'Zip/Postal Code is limited to ${max} characters')
      .matches(NOT_BLANK_REGEX, 'Zip/Postal Code is mandatory.'),
    country: yup.string().matches(NOT_BLANK_REGEX, 'Country is mandatory.'),
    packingInstructions: yup
      .string()
      .max(150, 'Special Instructions is limited to ${max} characters'),
    method: yup
      .string()
      .matches(NOT_BLANK_REGEX, 'Shipping Method is mandatory.')
      .oneOf(methodOptions, 'Shipping Method is invalid.'),
  });
};
